import axios from "axios";
import { USER_LOGOUT, SET_USER, SET_USER_ERROR } from "../types";
import { Storage } from './../../utils/storage';
import ToastMessage from '../../components/toast';
import { ipInfoToken } from "../../utils/constants";

export const loginAction = (credentials) => {
    return async (dispatch) => {
        let myIp = await axios.get(`https://ipinfo.io?token=${ipInfoToken}`).catch(er => er);
        axios.post('api/user/login', { ...credentials, clientIp: myIp?.data?.ip || "Unknown" }).then(response => {
            if (!response?.data) {
                dispatch({
                    type: SET_USER_ERROR,
                    payload: {
                        data: "Error Fetching data",
                        error: true
                    }
                });
                return ToastMessage("Error Fetching data", "error");
            };
            let { username, company } = credentials;
            let { data, companyDetails, userDetails, permissions, authorization } = response.data;
            let user = { username, company: company.toUpperCase(), role: (userDetails.portalAccess || "Client"), ...data, companyDetails, userDetails, permissions, authorization };
            user.companyId = companyDetails._id;
            user.compSystemId = companyDetails.companyId;
            if (companyDetails.companyType === 'Admin' && !userDetails.role) {
                dispatch({
                    type: SET_USER_ERROR,
                    payload: {
                        data: "Not Authorized to sign-in, please contact your system Admin",
                        status: 403,
                        statusMessage: "FORBIDDEN",
                        error: true
                    }
                });
                ToastMessage("Not Authorized to sign-in, please contact your system Admin", "error");
            } else {
                Storage.setItem("USER", user);
                dispatch({
                    type: SET_USER,
                    payload: user
                });
            };
        }).catch(e => {
            dispatch({
                type: SET_USER_ERROR,
                payload: {
                    e, error: true
                }
            });
            ToastMessage(e.response?.data, "error");
        });
    };
};
export const refreshUserAction = () => {
    const USER = Storage.getItem("USER");
    return {
        type: SET_USER,
        payload: USER || {}
    }
};

export const loginAsUser = (payload) => {
    return async dispatch => {
        await axios.get('api/user/login-as', { params: payload }).then(response => {
            let user = Storage.getItem("USER");
            user.token = response.data;
            Storage.setItem("USER", user);
            return dispatch({
                type: SET_USER,
                payload: user
            });
        }).catch(e => {
            return dispatch({
                type: SET_USER_ERROR,
                payload: {
                    e, error: true
                }
            });
        });
    };
};

export const refreshToken = () => {
    return (dispatch) => {
        axios.get(`api/user/refresh-token`).then(response => {
            let user = Storage.getItem("USER");
            user.token = response.data;
            Storage.setItem("USER", user);
            dispatch({
                type: SET_USER,
                payload: user
            });
        }).catch(e => {
            dispatch({
                type: SET_USER_ERROR,
                payload: {
                    e, error: true
                }
            });
        });
    };
};
export const refreshAuth = () => {
    return (dispatch) => {
        axios.get(`api/user/refresh-auth`).then(response => {
            let user = Storage.getItem("USER");
            user.authorization = response.data;
            Storage.setItem("USER", user);
            dispatch({
                type: SET_USER,
                payload: user
            });
        }).catch(e => {
            dispatch({
                type: SET_USER_ERROR,
                payload: {
                    e, error: true
                }
            });
        });
    };
};
export const logout = () => {
    Storage.clearAll();
    return dispatch => {
        dispatch({
            type: USER_LOGOUT,
            payload: {}
        });
    };
};
